import React, { forwardRef, useState } from "react";
import IntlMessages from "../../utils/messages";
import {
  Checkpoint,
  CheckpointType,
} from "../../lib/ground-aws-graphql-core/models/Api/Inspection";
import { getTranslation } from "../../utils/translation";
import classNames from "classnames";
import images from "../../images";
import ModalAddCheckpoint from "./checkpoint-modal";
import { ActionTypes } from "../../utils/types";
import { IntlShape } from "react-intl";
import ListCheckpoints from "./list-checkpoints";

interface Props {
  intl: IntlShape;
  item: CheckpointType;
  onAddCheckpoint: (t: CheckpointType, u: Checkpoint) => void;
  onRemoveCheckpoint: (t: CheckpointType, a: Checkpoint) => void;
  items: {
    checkpointType: CheckpointType;
    checkpoint: Checkpoint;
    action: ActionTypes;
  }[];
}

const CheckpointTypeComponent = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { item, items, onRemoveCheckpoint } = props;
    const [open, setOpen] = useState(false);
    const [image, setImage] = useState(images.add);

    const toggleModal = () => setOpen(prev => !prev);
    const handleMouseEnter = () => setImage(images.addBlue);
    const handleMouseLeave = () => setImage(images.add);

    const getStatusClass = (enabled: boolean) =>
      classNames(
        "absolute top-0 right-0 block h-2 w-2 rounded-full text-white shadow-solid",
        { "bg-red-400": !enabled, "bg-green-400": enabled }
      );

    return (
      <div
        ref={ref}
        className="bg-white shadow overflow-hidden sm:rounded-lg mt-10"
      >
        <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center">
          <h3 className="text-16px leading-6 font-medium text-gray-900">
            <span className="inline-block relative">
              <span className="mr-3">{getTranslation(item.title)}</span>
              <span className={getStatusClass(item.enabled)} />
            </span>
          </h3>

          <div
            className="flex items-center cursor-pointer hover:text-ground-blue-100 text-ground-gray-100"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            data-cy="btn-add-checkpoint"
            onClick={toggleModal}
          >
            <img alt="add-checkpoint" src={image} />
            <span className="hidden sm:block text-12px pr-2">
              <IntlMessages id="general.add" />
            </span>
          </div>

          {open && (
            <ModalAddCheckpoint
              {...props}
              checkpointType={item}
              isOpen={open}
              onRequestClose={toggleModal}
            />
          )}
        </div>

        <ListCheckpoints
          checkpointType={item}
          items={items}
          onRemoveCheckpoint={onRemoveCheckpoint}
        />
      </div>
    );
  }
);

CheckpointTypeComponent.displayName = "CheckpointTypeComponent";

export default CheckpointTypeComponent;
